import React from 'react';
import { Box } from 'bumbag';
import _get from 'lodash/get';

import { TRANSACTION_STATUSES } from '@medipass/utils/constants';
import { getOverrideStatus } from '@medipass/utils/transaction-status';

import TransactionListItem from './TransactionsListItem';
type Props = {
  items: Array<Record<string, any>>;
  isQuote?: boolean;
};

const TransactionsList = ({ items, isQuote }: Props) => {
  return (
    <Box>
      {items.map(item => {
        const isRequested = item.status === TRANSACTION_STATUSES.REQUESTED;
        const linkTo = isQuote ? `/account/quotes/view/?id=${item._id}` : `/account/transactions/view/?id=${item._id}`;
        let status = item.status;

        if (isQuote) {
          status = isRequested ? TRANSACTION_STATUSES.REQUESTED : '';
        }
        // @ts-expect-error
        const secondaryStatus = getOverrideStatus(item);
        return _get(item, 'payments.length', 0) > 0 ? (
          [...item.payments].reverse().map((payment, i) => {
            const isRefund = payment.paymentType === 'refund';
            let paymentStatus = status;

            if (status === TRANSACTION_STATUSES.PARTIALLY_REFUNDED) {
              paymentStatus = TRANSACTION_STATUSES.COMPLETED;
            }

            if (isRefund) {
              paymentStatus = TRANSACTION_STATUSES.REFUNDED;
            }

            return (
              <TransactionListItem
                // eslint-disable-next-line react/no-array-index-key
                key={`${item._id}-${i}`}
                /* eslint-disable-line react/no-array-index-key */
                amountString={`${isRefund ? '-' : ''}${payment.amountString}`}
                dateString={
                  isRefund ? payment.responded : payment.paymentDateString || payment.responded || payment.requested
                }
                isQuote={isQuote}
                item={item}
                linkTo={`${linkTo}&paymentId=${payment.paymentId}`}
                secondaryStatus={secondaryStatus}
                status={paymentStatus}
              />
            );
          })
        ) : (
          <TransactionListItem
            key={`${item._id}-0`}
            amountString={item.amountOutOfPocketString}
            dateString={item.created}
            isQuote={isQuote}
            item={item}
            linkTo={linkTo}
            secondaryStatus={secondaryStatus}
            status={status}
          />
        );
      })}
    </Box>
  );
};

TransactionsList.defaultProps = {
  isQuote: false,
};
export default TransactionsList;
